import { createContext, useState } from 'react'

import { IOrderProductionDetails } from '../../sdk/order-production/order-production.types'
import { sdk } from '../../services/sdk'

interface OrderProductionDataContext {
  orderProduction?: IOrderProductionDetails

  actions: {
    getOrderProduction: (code: string) => Promise<void>
  }
}

interface OrderProductionProviderProps {
  children: React.ReactNode
}

export const OrderProductionContext = createContext(
  {} as OrderProductionDataContext,
)

export function OrderProductionProvider(props: OrderProductionProviderProps) {
  const [orderProduction, setOrderProduction] =
    useState<IOrderProductionDetails>()

  const getOrderProduction = async (code: string) => {
    const _response = await sdk.orderProduction.getOrderProduction(code)
    setOrderProduction(_response)
  }

  return (
    <OrderProductionContext.Provider
      value={{
        orderProduction,

        actions: {
          getOrderProduction,
        },
      }}
    >
      {props.children}
    </OrderProductionContext.Provider>
  )
}
